/* eslint-disable import/no-cycle */
// this file is created to reduce initial bundle size, will keep all utils which are used in index.js file
import axios from 'axios';
import { Logtail } from '@logtail/browser';
import { getLogtailEndpoint, BaseURL, getLogtailKey } from './config';
import { mutexManager, StaticMutexKeys } from './common/mutexmanager';
import { logRuntimeError } from './common/utils';
import { abortController } from './common/abort-handler';

const logtailKey = getLogtailKey();
const logtailEndpoint = getLogtailEndpoint();
let logtail = null;
if (logtailKey && logtailEndpoint) {
  logtail = new Logtail(logtailKey, {
    endpoint: logtailEndpoint,
  });
}

export function getCountryCodeUtils() {
  if (window.Shopify) {
    const { country } = window.Shopify;
    return country;
  }
  return '';
}

export function getShopUtils() {
  if (window.Shopify.shop) {
    return window.Shopify.shop;
  }

  const {
    ShopifyAnalytics: {
      lib: {
        config: { Trekkie: { defaultAttributes: { shopId } = {} } = {} } = {},
      } = {},
    } = {},
  } = window;

  if (shopId) {
    if (shopId === 61805002909) {
      return 'quirky-perks-new.myshopify.com';
    }
  }
  return '';
}

export function sleepUtils(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export async function delayIfNeededUtils() {
  if (getShopUtils() === 'covry-sunwear.myshopify.com') {
    await sleepUtils(1000);
  }
}

export function isShopifyThemeEditorUtils() {
  if (window.Shopify && window.Shopify.designMode) {
    return window.Shopify.designMode;
  }
  return false;
}

export function getPageUtils() {
  if (window.ShopifyAnalytics) {
    if (window.ShopifyAnalytics.meta.page) {
      switch (window.ShopifyAnalytics.meta.page.pageType) {
        case 'product':
          return 'product';
        case 'collection':
          return 'collection';
        case 'home':
          return 'home';

        default:
          if (window.location.pathname.endsWith('/cart')) {
            return 'cart';
          }
          if (window.location.pathname.endsWith('/cart/')) {
            return 'cart';
          }
          return 'unknown';
      }
    }
  }

  if (isShopifyThemeEditorUtils()) {
    if (window.location.pathname.endsWith('/cart')) {
      return 'cart';
    }
    if (window.location.pathname.startsWith('/products/')) {
      return 'product';
    }
  }
  return 'unknown';
}

export function getThemeUtils() {
  if (window.Shopify && window.Shopify.theme) {
    const { id, theme_store_id, role, handle } = window.Shopify.theme;
    let { name } = window.Shopify.theme;

    // in case theme store id is null then use shopify boomerang
    if (!theme_store_id && window.BOOMR && window.BOOMR.themeName) {
      name = window.BOOMR.themeName;
    }

    return { name, id, theme_store_id, role, handle };
  }
  return {};
}

export function getCurrencyUtils() {
  if (window.Shopify && window.Shopify.currency) {
    const { active } = window.Shopify.currency;
    return active;
  }
  return '';
}

export function isCartPageUtils() {
  return getPageUtils() === 'cart';
}

export function isDraftThemeUtils() {
  if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) {
    return window.Shopify.theme.role !== 'main';
  }
  return false;
}

export function resetDataUtils() {
  removeArrowDiscountUtils();
}

export function removeArrowDiscountUtils() {
  sessionStorage.removeItem('mrArrowTotal');
}

export const loggerUtils = {
  log: (...data) => {
    if (localStorage.getItem('mr-debug')) {
      // eslint-disable-next-line no-console
      console.log(...data);
    }
  },
  Debug: (...data) => {
    if (localStorage.getItem('mr-debug')) {
      // eslint-disable-next-line no-console
      console.log('[DEBUG]', data);
    }
  },
  serverInfoLog: (message, metadata) => {
    if (logtail) {
      logtail.info(message, metadata);
      logtail.flush();
    } else {
      // eslint-disable-next-line no-console
      console.log(message, metadata);
    }
  },
  serverErrorLog: (message, metadata) => {
    if (logtail) {
      logtail.error(message, metadata);
      logtail.flush();
    } else {
      // eslint-disable-next-line no-console
      console.error(message, metadata);
    }
  },
};

export function getUTMDataUtils() {
  try {
    const stringified = sessionStorage.getItem('mr_utm');
    if (stringified) {
      const obj = JSON.parse(stringified);
      if (obj) {
        return obj;
      }
    }
    return {};
  } catch (e) {
    loggerUtils.log('error in utm', e);
    // using it instead of logger function to avoid cyclic dependency
    return {};
  }
}

export function setUTMDataUtils(data) {
  sessionStorage.setItem('mr_utm', JSON.stringify(data));
}

export async function storeUTMDataUtils() {
  const data = getUTMDataUtils();
  const {
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    fbclid,
    landing_page,
    mr_discount_code,
  } = data;
  let updated = false;

  let visitData = {};
  if (getShopUtils() === 'fittify-in.myshopify.com') {
    try {
      const lib = await import('mr-components');
      visitData = lib.getVisitorData();
    } catch (e) {
      loggerUtils.log(e);
      // using it instead of logger function to avoid cyclic dependency
    }
  }
  const { source, medium, campaign, content } = visitData;

  // utm_source=facebook&utm_medium=cpc&utm_campaign=skin-advantage-nov-22&utm_content=video-ad
  const urlSearchParams = new URLSearchParams(window.location.search);
  const newSource = source || urlSearchParams.get('utm_source');
  const newMedium = medium || urlSearchParams.get('utm_medium');
  const newCampaign = campaign || urlSearchParams.get('utm_campaign');
  const newContent = content || urlSearchParams.get('utm_content');
  const newFbClickID = urlSearchParams.get('fbclid');
  const newMrDiscountCode = urlSearchParams.get('mrFdc');
  const newLandingPage = window.location.pathname;
  if (!utm_source && newSource) {
    updated = true;
    data.utm_source = newSource;
  }
  if (!utm_medium && newMedium) {
    updated = true;
    data.utm_medium = newMedium;
  }
  if (!utm_campaign && newCampaign) {
    updated = true;
    data.utm_campaign = newCampaign;
  }
  if (!utm_content && newContent) {
    updated = true;
    data.utm_content = newContent;
  }
  if (!utm_content && newContent) {
    updated = true;
    data.utm_content = newContent;
  }
  if (!fbclid && newFbClickID) {
    updated = true;
    data.fbclid = newFbClickID;
  }
  if (!landing_page && newLandingPage) {
    updated = true;
    data.landing_page = newLandingPage;
  }

  if (!mr_discount_code && newMrDiscountCode) {
    updated = true;
    data.mr_discount_code = newMrDiscountCode;
  }

  if (updated) {
    setUTMDataUtils(data);
  }
}

function getBaseURLUtils() {
  return BaseURL;
}

export function getShopConfigEndpointUtils() {
  return `${getBaseURLUtils()}/app/shop/config`;
}

export function getCurrencyRateUtils() {
  if (window.Shopify && window.Shopify.currency) {
    const { rate } = window.Shopify.currency;
    return rate;
  }
  return '1.0';
}

export function getLocaleUtils() {
  if (window.Shopify) {
    const { locale } = window.Shopify;
    return locale;
  }
  return '';
}

export const getCustomerIdUtils = () => {
  let curr = null;
  try {
    curr = window.ShopifyAnalytics.meta.page.customerId;
  } catch (e) {
    loggerUtils.log(e);
  }
  try {
    curr = window.meta.page.customerId;
  } catch (e) {
    loggerUtils.log(e);
  }
  try {
    // eslint-disable-next-line no-underscore-dangle
    curr = window.__st.cid;
  } catch (e) {
    loggerUtils.log(e);
  }

  if (curr !== undefined && curr !== null && curr !== '') {
    return curr;
  }

  return null;
};

export function getPreviewModeUtils() {
  return sessionStorage.getItem('mrIsPreviewMode');
}

export function getOfferPerformanceEndpointUtils() {
  return `${getBaseURLUtils()}/app/exec`;
}

export const logAPIResponseUtils = async (url, data, start, clonedResp) => {
  const now = new Date();
  const isEnabled = false;
  if (isEnabled) {
    setTimeout(() => {
      try {
        // import('./constants').then(lib => {

        // });
        const base = 'https://api.monkcommerce';
        // const base = 'https://rahultempbe.';
        if (url.endsWith('/app/offer') && url.includes(base)) {
          clonedResp.json().then(val => {
            const { execution_time, offer, is_eligible } = val;
            if (is_eligible) {
              const { mr_offer_id: offerID } = offer;
              const { offerType } = data;
              postDataUtils(getOfferPerformanceEndpointUtils(), {
                endpoint: 'offer',
                data: {
                  offerType,
                  isEligible: is_eligible,
                  respTime: now - start,
                  execTime: execution_time,
                  offerID,
                },
              });
            }
          });
        }
      } catch (e) {
        loggerUtils.log(e);
      }
    }, 5000);
  }
  return true;
};

export function postDataUtils(url = '', data = {}) {
  const { signal } = abortController;

  data.shop_url = getShopUtils();
  data.page = getPageUtils();
  data.currency_code = getCurrencyUtils();
  data.country_code = getCountryCodeUtils();
  data.conversion_rate = getCurrencyRateUtils();
  data.utm = getUTMDataUtils();
  data.locale = getLocaleUtils();
  data.customerId = getCustomerIdUtils();
  data.isPreview = getPreviewModeUtils() === 'true';
  const start = new Date();

  // Default options are marked with *
  return (
    fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      // mode: 'cors', // no-cors, *cors, same-origin
      // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      signal,
      // redirect: 'follow', // manual, *follow, error
      // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    })
      // eslint-disable-next-line consistent-return
      .then(response => {
        const end = new Date();
        const responseTime = end - start;

        if (response.status === 200) {
          logAPIResponseUtils(url, data, start, response.clone());
          return response.json();
        }
        throw new Error(
          `Error in postData ${response.status} ${responseTime} ms`,
        );
      })
      .catch(e => {
        const end = new Date();
        const responseTime = end - start;

        const endpoint = url.split('/').pop();
        const errorData = {};
        if (data.cart_token) {
          errorData.cartToken = data.cart_token;
        }

        // Check if the error contains a response object (common in axios or fetch)
        let statusCode = null;
        if (e.response) {
          statusCode = e.response.status;
        } else if (e instanceof Response) {
          statusCode = e.status;
        }

        const errorMessage =
          e.name === 'AbortError'
            ? `${endpoint} aborted`
            : `${endpoint} failed`;

        logRuntimeError({
          errorMessage,
          errorData: {
            fileName: 'index-utils',
            functionName: 'postDataUtils',
            level: 'error',
            extraErrorData: errorData,
            errorMessage: e.message,
            responseTime,
            statusCode,
            data,
            errorName: e.name,
          },
          errorStack: e,
        });
        return null;
      })
  );

  // return response.json(); // parses JSON response into native JavaScript objects
}

export function getPTIDUtils() {
  return sessionStorage.getItem('ptid');
}

export function getFriendsRefUtils() {
  return sessionStorage.getItem('friends_ref');
}

export const UPDATE_CART_API_UTILS = `/cart/update.js?mr=1`;
export const FETCH_CART_API_UTILS = `/cart.js?mr=1`;

export async function fetchCartUtils() {
  const response = await fetch(FETCH_CART_API_UTILS, {
    method: 'GET',
    headers: {
      pragma: 'no-cache',
      'cache-control': 'no-cache',
    },
  });
  const cart = await response.json();
  loggerUtils.log('fetched cart', cart);
  if (cart.items) {
    loggerUtils.log('cart items', cart.items.length);
  }
  return cart;
}

export async function addShopifyFunctionsAttributeToCartUtils(orderid) {
  const formData = {
    attributes: { _mrOrderID: orderid },
  };

  // additional attribute for a store
  if (getPTIDUtils()) {
    formData.attributes.postback_ptid = getPTIDUtils();
  }

  if (getFriendsRefUtils()) {
    formData.attributes.friends_ref = getFriendsRefUtils();
  }

  // the merchant wanted no attributes, so we skip the call
  // they are fine with no attribution
  if (getShopUtils() === 'spiral-light-candles.myshopify.com') {
    return;
  }

  // the merchant wanted no attributes, so we skip the call
  // they are fine with no attribution
  if (getShopUtils() === 'big-star-lights-na.myshopify.com') {
    return;
  }

  const httpArgs = [`${UPDATE_CART_API_UTILS}&mrs=1`, formData];
  try {
    const cart = await fetchCartUtils();
    if (cart) {
      const { attributes } = cart;
      if (attributes) {
        const { _mrOrderID } = attributes;
        if (_mrOrderID === orderid) return;
      }
    }

    await axios.post(...httpArgs);
  } catch (e) {
    loggerUtils.log(e);
  }
}

export function getMRCartFromShopifyCartUtils(cart) {
  // NOTE: modifying anything here should be replicated in functions mrcart conversion
  const mrCart = [];
  for (let i = 0; i < cart.items.length; i += 1) {
    const item = {};
    item.sp_product_id = cart.items[i].product_id;
    item.sp_variant_id = cart.items[i].variant_id;
    item.quantity = cart.items[i].quantity;
    item.variant_title = cart.items[i].variant_title
      ? cart.items[i].variant_title
      : cart.items[i].title;
    item.properties = cart.items[i].properties;
    item.price = cart.items[i].original_price / 100;
    item.key = cart.items[i].key;
    item.discounted_price = cart.items[i].discounted_price / 100;
    if (['173140-3.myshopify.com'].includes(getShopUtils())) {
      item.discounted_price = cart.items[i].line_price / item.quantity;
      item.discounted_price /= 100;
      loggerUtils.log('discounted price', item.discounted_price, i);
    }
    item.line_level_discount_allocations =
      cart.items[i].line_level_discount_allocations;

    // preserve the order of properties
    if (item.properties) {
      item.properties_order = Object.keys(cart.items[i].properties);
    }
    const { selling_plan_allocation } = cart.items[i];
    if (selling_plan_allocation) {
      const { selling_plan } = selling_plan_allocation;
      if (selling_plan) {
        const { id: selling_plan_id } = selling_plan;
        if (selling_plan_id) {
          item.selling_plan_allocation = {
            selling_plan: {
              id: selling_plan_id,
            },
          };
        }
      }
    }
    mrCart.push(item);
  }
  return mrCart;
}

export function getShipProVariantsUtils() {
  try {
    const obj = JSON.parse(localStorage.getItem('mr_em_ship_pro_variants'));
    if (!obj) return [];
    return obj;
  } catch (e) {
    return [];
  }
}

export function getWindoKeyUtils(key) {
  return window[key];
}

export function debounceUtils(func, timeout = 5000) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export function getCartListenerSelectorsObjectUtils({
  cartPageListenerSelector,
  cartPageListenerFunction,
  cartDrawerListenerSelector,
  cartDrawerListenerFunction,
  cartCountListenerSelector,
  cartCountListenerFunction,
}) {
  return {
    cartPage: {
      selector: cartPageListenerSelector,
      listenerTriggerFunction: cartPageListenerFunction,
    },
    cartDrawer: {
      selector: cartDrawerListenerSelector,
      listenerTriggerFunction: cartDrawerListenerFunction,
    },
    cartCount: {
      selector: cartCountListenerSelector,
      listenerTriggerFunction: cartCountListenerFunction,
    },
  };
}

export const sectionsToUpdateHtmlUtils = [
  'cartPage',
  'cartDrawer',
  'cartCount',
];

export function triggerRerenderCartUtils() {
  const configs = getWindoKeyUtils('mrUpsellConfig');
  const {
    cartListener: {
      cartListenerTriggerMethod,
      cartPageListenerSelector,
      cartPageListenerFunction,
      cartDrawerListenerSelector,
      cartDrawerListenerFunction,
      cartCountListenerSelector,
      cartCountListenerFunction,
    },
  } = configs;

  if (cartListenerTriggerMethod === 'selector') {
    // here we convert the fields into an object so that we can easily access them
    const cartListenerSelectorObj = getCartListenerSelectorsObjectUtils({
      cartPageListenerSelector,
      cartPageListenerFunction,
      cartDrawerListenerSelector,
      cartDrawerListenerFunction,
      cartCountListenerSelector,
      cartCountListenerFunction,
    });

    // We loop over the sections that need to be updated and trigger the function
    sectionsToUpdateHtmlUtils.forEach(section => {
      const { selector, listenerTriggerFunction } = cartListenerSelectorObj[
        section
      ];
      if (selector && listenerTriggerFunction) {
        const element = document.querySelector(selector);
        // the function is executed only if the element is present in the DOM and the function is associated with the element
        if (element && element[listenerTriggerFunction]) {
          element[listenerTriggerFunction]();
        }
      }
    });
  }

  loggerUtils.Debug('trigger rerender cart');

  loggerUtils.log('mr - trigger rerender cart');

  loggerUtils.log('mr - cart:refresh');
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:refresh', {
      bubbles: true,
    }),
  );

  loggerUtils.log('mr - ajaxProduct:added');
  document.documentElement.dispatchEvent(
    new CustomEvent('ajaxProduct:added', {
      bubbles: true,
    }),
  );

  loggerUtils.log('mr - product:added');
  document.documentElement.dispatchEvent(
    new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        quantity: 0,
      },
    }),
  );

  loggerUtils.log('mr - theme:cart:reload');
  document.documentElement.dispatchEvent(
    new CustomEvent('theme:cart:reload', {
      bubbles: true,
    }),
  );

  loggerUtils.log('mr - apps:product-added-to-cart');
  document.documentElement.dispatchEvent(
    new CustomEvent('apps:product-added-to-cart', {
      bubbles: true,
    }),
  );

  loggerUtils.log('mr - added');
  document.body.dispatchEvent(new CustomEvent('added', { bubbles: true }));

  loggerUtils.log('mr - cart:refresh');
  document.documentElement.dispatchEvent(
    new CustomEvent('theme:cartchanged', {
      bubbles: true,
    }),
  );

  loggerUtils.log('mr - _cart-update');
  document.documentElement.dispatchEvent(
    new CustomEvent('_cart-update', {
      bubbles: true,
    }),
  );

  loggerUtils.log('mr - dispatch:cart-drawer:refresh');
  document.documentElement.dispatchEvent(
    new CustomEvent('dispatch:cart-drawer:refresh', {
      bubbles: true,
    }),
  );

  loggerUtils.log('mr - ajaxCartEle');
  const ajaxCartEle = document.querySelector('ajax-cart');
  if (ajaxCartEle && ajaxCartEle.refreshCart) {
    ajaxCartEle.refreshCart();
  }

  // zag-bijoux.myshopify.com
  // theme testament
  if (
    window.Shopify &&
    window.Shopify.theme &&
    window.Shopify.theme.ajaxCart &&
    window.Shopify.theme.ajaxCart.initializeAjaxCart
  ) {
    loggerUtils.log('mr - initializeAjaxCart');
    let config = document.getElementById('cart-config');
    config = JSON.parse(config.innerHTML || '{}');
    window.Shopify.theme.ajaxCart.initializeAjaxCart(config);
  }

  //  rustic-territory.myshopify.com
  if (
    window.spratlyTheme &&
    window.spratlyTheme.Cart &&
    window.spratlyTheme.Cart.renderNewCart
  ) {
    loggerUtils.log('mr - renderNewCart');
    window.spratlyTheme.Cart.renderNewCart();
  }

  if (window.cart && window.cart.getCart) {
    loggerUtils.log('mr - getCart');
    window.cart.getCart();
  }

  if (window.Udesly && window.Udesly.dispatch) {
    loggerUtils.log('mr - cart-should-be-updated');
    window.Udesly.dispatch('cart-should-be-updated');
  }

  loggerUtils.log('mr - theme:cart:reload');
  document.dispatchEvent(new CustomEvent('theme:cart:reload'));

  loggerUtils.log('mr - dispatch:cart-drawer:refresh');
  document.documentElement.dispatchEvent(
    new CustomEvent('dispatch:cart-drawer:refresh', {
      bubbles: true,
    }),
  );

  if (['muse-india.myshopify.com'].includes(getShopUtils())) {
    if (window.MinimogEvents && window.MinimogTheme) {
      const { MinimogEvents, MinimogTheme } = window;
      MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { source: '' });
    }
  }
  const drawer = document.querySelector('m-cart-drawer');
  if (drawer) {
    drawer.onCartDrawerUpdate();
  }

  const cart = document.querySelector('m-cart');
  if (cart) {
    cart.onCartUpdate();
  }

  if (
    [
      'enjoyfrolic.myshopify.com',
      'the-sill.myshopify.com',
      'uk-escentual.myshopify.com',
    ].includes(getShopUtils())
  ) {
    const cartDrawer =
      document.querySelector('cart-items') ||
      document.querySelector('cart-drawer-items');
    if (cartDrawer) {
      cartDrawer.onCartUpdate();
    }
  }

  if (
    window.publish &&
    [
      'peach-la.myshopify.com',
      '77f512-b7.myshopify.com',
      '456848-2f.myshopify.com',
      'devwebsensepro.myshopify.com',
      'shopisoap.myshopify.com',
      'zenyogi-threads.myshopify.com',
      'ben-development-2.myshopify.com',
      'lypzo.myshopify.com',
      '1c6be5-2c.myshopify.com',
      'c30d9d.myshopify.com',
      'xked4z-uk.myshopify.com',
    ].includes(getShopUtils())
  ) {
    loggerUtils.log('pubsub event refresh');
    window.publish('cart-update', { source: '' });
  }

  if (['cellcosmet-us-production.myshopify.com'].includes(getShopUtils())) {
    if (window.pubsub && window.pubsub.publish) {
      const { pubsub } = window;
      pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, {});
    }
  }

  if (['2f3d7a-2.myshopify.com'].includes(getShopUtils())) {
    const mainCart = document.querySelector('cart-items');
    const cartPopup = document.querySelector('mini-cart');
    if (mainCart) mainCart.onCartRefresh();
    if (cartPopup) cartPopup.onCartRefresh();
  }

  if (
    ['dermalogicano.myshopify.com', 'ex-voto-vintage.myshopify.com'].includes(
      getShopUtils(),
    )
  ) {
    const pageHeader = document.querySelector('page-header');
    const cartForm = document.querySelector('cart-form');
    if (cartForm) cartForm.refresh();
    if (pageHeader) pageHeader.refreshHeader();
  }

  if (['grassphere.myshopify.com'].includes(getShopUtils())) {
    const grassphereCartDrawer = document.querySelector('cart-drawer');
    if (grassphereCartDrawer) {
      // eslint-disable-next-line no-underscore-dangle
      grassphereCartDrawer._rerenderCart({ detail: null });
    }
  }

  if (['987a28-05.myshopify.com'].includes(getShopUtils())) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) cartDrawer.update();
  }

  if (
    ['wolfpupcreative.myshopify.com', 'murdycreativeco.myshopify.com'].includes(
      getShopUtils(),
    )
  ) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:build', {
        bubbles: true,
      }),
    );
  }

  // store specific
  if (
    ['malelions-productie.myshopify.com', '3fe984-4b.myshopify.com'].includes(
      getShopUtils(),
    )
  ) {
    if (window.cart && window.cart.getCart) {
      window.cart.getCart();
    }
  }

  // store specific
  if (['initio-parfums-prives-dev.myshopify.com'].includes(getShopUtils())) {
    if (window.Cart2 && window.Cart2.updateCart) {
      window.Cart2.updateCart(false);
    }
  }

  // store specific
  if (getShopUtils() === 'noprintfitness.myshopify.com') {
    const cartPageElement = document.querySelector('#CartPageForm');
    if (cartPageElement && window.theme && window.theme.CartForm) {
      const cf = new window.theme.CartForm(cartPageElement);
      if (cf) {
        cf.buildCart();
      }
    }
  }

  if (
    [
      '23f5ec-2.myshopify.com',
      'ec1186-69.myshopify.com',
      'dailyvip.myshopify.com',
    ].includes(getShopUtils())
  ) {
    if (window.theme && window.theme.ajaxCart && window.theme.ajaxCart.update) {
      window.theme.ajaxCart.update();
    }
  }

  if (
    [
      '9feeae-2.myshopify.com',
      'b05953-2.myshopify.com',
      'onlysmile-club.myshopify.com',
    ].includes(getShopUtils())
  ) {
    const aCart = document.querySelector('cart-items');
    if (aCart && aCart.onCartUpdate) {
      aCart.onCartUpdate();
    }
  }

  if (getShopUtils() === '7afc27-c1.myshopify.com' && window.ajaxCart) {
    if (isCartPageUtils() && window.ajaxCart.init) window.ajaxCart.init();
    else if (window.ajaxCart.load) window.ajaxCart.load();
  }

  if (window.MinimogTheme) {
    if (window.MinimogTheme.Cart && window.MinimogTheme.Cart.renderNewCart) {
      window.MinimogTheme.Cart.renderNewCart();
    }
  }

  if (
    [
      'thebrowshop.myshopify.com',
      'thelashshop-intl.myshopify.com',
      'the-lash-shop-canada.myshopify.com',
      'cancha-bags.myshopify.com',
      'simplytrees-5791.myshopify.com',
    ].includes(getShopUtils())
  ) {
    if (window.refreshCart) window.refreshCart();
  }

  if (
    [
      'bystenholt.myshopify.com',
      'd69704.myshopify.com',
      '597de9-17.myshopify.com',
      'vqt8uy-0u.myshopify.com',
    ].includes(getShopUtils())
  ) {
    const CartItemsElem = document.querySelector('cart-items');
    if (CartItemsElem) CartItemsElem.getCart();
  }

  if (['claudioluglishirts.myshopify.com'].includes(getShopUtils())) {
    const cartItemsElem = document.querySelector('cart-items');
    if (cartItemsElem) cartItemsElem.renderAndShowItems();
  }

  if (['melissa-harvey.myshopify.com'].includes(getShopUtils())) {
    const cartElem = document.querySelector('cart-items');
    if (cartElem && isCartPageUtils())
      document.querySelector('cart-items').refreshCart();
    const cartDarwerElem = document.querySelector('mini-cart');
    if (cartDarwerElem) document.querySelector('mini-cart').refreshCart();
  }

  if (
    [
      'initio-parfums-prives.myshopify.com',
      'initio-parfums-prives-uae.myshopify.com',
      'initio-parfums-prives-uk.myshopify.com',
      'initio-parfums-prives-us.myshopify.com',
      'initio-parfums-prives-dev.myshopify.com',
    ].includes(getShopUtils())
  ) {
    if (window.Cart2 && window.Cart2.updateCart) {
      window.Cart2.updateCart(false);
    }
  }

  if (['unmute-greetings.myshopify.com'].includes(getShopUtils())) {
    if (window.theme && window.theme.cart && window.theme.cart.rerenderCart) {
      window.theme.cart.rerenderCart();
    }
  }
}

export const debouncedRefreshAJAXCartUtils = debounceUtils(
  triggerRerenderCartUtils,
  2500,
);
export const debouncedRefreshAJAXCart2Utils = debounceUtils(
  triggerRerenderCartUtils,
  1500,
);

export function refreshAJAXCartUtils() {
  loggerUtils.log('mr - refreshAJAXCart');
  if (
    ['wndr-alpine-staging.myshopify.com', 'wndr-alpine.myshopify.com'].includes(
      getShopUtils(),
    )
  ) {
    debouncedRefreshAJAXCartUtils();
    return;
  }

  if (
    ['dottyclub.myshopify.com', '1c6be5-2c.myshopify.com'].includes(
      getShopUtils(),
    )
  ) {
    debouncedRefreshAJAXCart2Utils();
    return;
  }
  triggerRerenderCartUtils();
}

export const updateCartUtils = async ({ updates, isSkipIntercept = false }) => {
  const shopifyCartMutex = mutexManager.getMutex(StaticMutexKeys.CART_MODIFY);
  try {
    if (Object.keys(updates).length > 0) {
      await shopifyCartMutex.acquire();

      const apiURL = isSkipIntercept
        ? `${UPDATE_CART_API_UTILS}&mrs=1`
        : UPDATE_CART_API_UTILS;
      // const httpArgs = [apiURL, { updates }];
      const response = await fetch(apiURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      loggerUtils.log(
        'cart updated',
        updates,
        response.status,
        JSON.stringify(response),
      );

      // failure to update
      if (response.status !== 200) {
        return false;
      }
      refreshAJAXCartUtils();
    }
  } catch (e) {
    loggerUtils.log('update error', e);
    logRuntimeError({
      errorMessage: 'update cart error',
      errorData: {
        fileName: 'index-utils',
        level: 'error',
        basicOfferData: {
          updates,
        },
      },
      errorStack: e,
    });
    return false;
  } finally {
    shopifyCartMutex.release();
  }
  // successfully updated
  return true;
};

export function removeShipProOfferIDUtils() {
  localStorage.removeItem('mr_em_ship_pro_offer_id');
}

export function removeShipProVariantsUtils() {
  localStorage.removeItem('mr_em_ship_pro_variants');
}

export function removeShipProAutoAddUtils() {
  sessionStorage.removeItem('mr_em_ship_pro_autoAdd');
}

export function isInaEssUtils() {
  return [
    'inaessentialspl.myshopify.com',
    'inaessentialsuk.myshopify.com',
    'inaessentialsro.myshopify.com',
    'inaessentials.myshopify.com',
    'evacosmeticsgr.myshopify.com',
    'inaessentials-cz.myshopify.com',
    'inaessentials-es.myshopify.com',
    'inaessentials-hr.myshopify.com',
    'inaessentials-nl.myshopify.com',
    'inaessentials-se-701.myshopify.com',
    'inaessentials-france.myshopify.com',
    'inaessentials-dk.myshopify.com',
    'inaessentialshu.myshopify.com',
    'inaessentialsie.myshopify.com',
    'inaessentials-it.myshopify.com',
    'inaessentials-pt.myshopify.com',
    'inaessentials-si.myshopify.com',
    'inaessentials-sk.myshopify.com',
    'inaessentials-rs.myshopify.com',
    'inaessentialsde.myshopify.com',
    'inaessentials-lv.myshopify.com',
    'inaessentials-lt.myshopify.com',
    'inaessentials-at.myshopify.com',
    'inaessentials-us.myshopify.com',
    'inaessentials-ua.myshopify.com',
  ].includes(getShopUtils());
}

export const reloadPageUtils = debounceUtils(
  () => window.location.reload(),
  2500,
);

export function setOpenDrawerUtils(val) {
  sessionStorage.setItem('mr_open_drawer', val);
}

export function getCartIconSelectorsUtils() {
  const configs = getWindoKeyUtils('mrUpsellConfig');
  return {
    selector: configs.embedded.cartIcon.selector,
  };
}

export const openCartDrawerUsingSelectorsUtils = async () => {
  const shopEventModule = await import('./features/shopEventModule');
  setOpenDrawerUtils('true');
  const cartIconConfig = getCartIconSelectorsUtils();
  shopEventModule.openCartDrawer({ cartIconConfig });
};

export function goToCartUtils({ isPopup, isRefreshPageAfterProductAddition }) {
  loggerUtils.log('go to cart');

  if (
    ['seevo-in.myshopify.com', '5e6a6c-1c.myshopify.com'].includes(
      getShopUtils(),
    )
  ) {
    window.location = '/cart';
    return true;
  }

  if (
    [
      'simply-nam.myshopify.com',
      'hoagard-au.myshopify.com',
      'foliagedreams.myshopify.com',
    ].includes(getShopUtils()) &&
    !isPopup
  ) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:open', {
        bubbles: true,
      }),
    );

    refreshAJAXCartUtils();
    return true;
  }

  if (isInaEssUtils() && !isPopup) {
    const icon = document.querySelector("a[href='/cart'].header__icon-wrapper");
    if (icon) {
      icon.setAttribute('aria-expanded', true);
      return true;
    }
  }

  if (isRefreshPageAfterProductAddition) {
    if (isCartPageUtils()) {
      loggerUtils.log('refresh initiated 58');
      reloadPageUtils();
      return true;
    }
    setOpenDrawerUtils('true');
    reloadPageUtils();
    loggerUtils.log('refresh initiated 64');
    return true;
  }
  openCartDrawerUsingSelectorsUtils();
  return true;
}

export const removeShipProAndModifyCartIfNotEnabledUtils = async ({
  mrCart,
  isRefresh,
}) => {
  loggerUtils.log('remove ship pro if any');
  if (!mrCart) {
    const cart = await fetchCartUtils();
    // eslint-disable-next-line no-param-reassign
    mrCart = getMRCartFromShopifyCartUtils(cart);
  }

  const updates = {};
  const storedVariantList = getShipProVariantsUtils();

  const commonVariants = mrCart.filter(obj1 =>
    storedVariantList.some(obj2 => obj1.sp_variant_id === obj2),
  );

  commonVariants.forEach(elem => {
    const { key } = elem;
    updates[key] = 0;
  });

  let cartChanged = false;

  if (Object.keys(updates).length > 0) {
    const success = await updateCartUtils({
      updates,
    });
    cartChanged = success;
  }

  removeShipProOfferIDUtils();
  removeShipProVariantsUtils();
  removeShipProAutoAddUtils();
  if (cartChanged && isRefresh) {
    goToCartUtils({
      isPopup: false,
      isRefreshPageAfterProductAddition: isRefresh,
    });
  }
  return cartChanged;
};

export function setIsDisabledUtils(val) {
  return sessionStorage.setItem('mrDisabled', val);
}

export function setOffersDisableUtils(triggerType) {
  // set floating as false
  // setFloating('false');
  sessionStorage.setItem(`mrOfferDisabled${triggerType}`, 'true');
}

export const customDisableProductTriggerUtils = () => {
  if (getShopUtils() !== 'setu-nutrition.myshopify.com') {
    return;
  }
  setOffersDisableUtils('product');
};

export function getOrderIDUtils() {
  return sessionStorage.getItem('mr_order_id');
}

export function setOrderIDUtils(orderid) {
  if (orderid === '') {
    return;
  }
  sessionStorage.setItem('mr_order_id', orderid);
}

export function setMrFreegiftDiscountCodeUtils(value) {
  sessionStorage.setItem('mrFreegiftDiscountCode', value);
}

export function extractFreegiftDiscountCodeFromURLUtils() {
  const url = new window.URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);

  const mrFdc = searchParams.get('mrfdc') || searchParams.get('mrFdc');

  // remove mrFdc from newURL
  if (mrFdc) {
    searchParams.delete('mrfdc');
    searchParams.delete('mrFdc');

    const searchParamsStr = searchParams.toString();
    const newURL = `${window.location.pathname}${
      searchParamsStr !== '' ? `?${searchParamsStr}` : ''
    }`;

    // store discount code in sessionStorage and update browser url for
    setMrFreegiftDiscountCodeUtils(mrFdc.toUpperCase());
    window.history.replaceState({}, '', newURL);
  }
}

export function getWithExpiryUtils(key) {
  const itemStr = sessionStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    sessionStorage.removeItem(key);
    return null;
  }
  return item.val;
}

export function setWithExpiryUtils(key, value, ttl) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    val: value,
    expiry: now.getTime() + ttl,
  };
  sessionStorage.setItem(key, JSON.stringify(item));
}

export function setWindowKeyUtils(key, value) {
  window[key] = value;
}

export function getFontSyncModeUtils() {
  return sessionStorage.getItem('mrIsFontSyncMode');
}

export function isFontSyncModeUtils() {
  if (getFontSyncModeUtils() === 'true') {
    return true;
  }
  const urlSearchParams = new URLSearchParams(window.location.search);
  const fontSyncMode = urlSearchParams.get('mrfsm');
  if (fontSyncMode) {
    return true;
  }

  return false;
}

export function setMerchantDiscountCodeUtils(value) {
  sessionStorage.setItem('mrAutoDiscountCode', value);
}

export function getCookieValueUtils(name) {
  try {
    const cookieString = document.cookie;
    const cookies = cookieString.split('; ');

    for (let i = 0; i < cookies.length; i += 1) {
      const cookie = cookies[i];
      const cookieParts = cookie.split('=');
      const cookieName = cookieParts[0];
      const cookieValue = cookieParts[1];

      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
  } catch (e) {
    loggerUtils.log(e);
  }
  return '';
}

export function extractMerchantDiscountCodeFromURLUtils() {
  const url = new window.URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);

  const mrdc = searchParams.get('mrdc');

  // remove mrdc from newURL
  if (mrdc) {
    searchParams.delete('mrdc');
    const searchParamsStr = searchParams.toString();
    const newURL = `${window.location.pathname}${
      searchParamsStr !== '' ? `?${searchParamsStr}` : ''
    }`;

    // store discount code in sessionStorage and update browser url
    setMerchantDiscountCodeUtils(mrdc);
    window.history.replaceState({}, '', newURL);
  }
}

export function setExternalDiscountCodeForFunctionsUtils() {
  const discountCode = getCookieValueUtils('discount_code');
  if (discountCode) {
    sessionStorage.setItem('mrSFExtDC', discountCode);
  }
}

export const getWidthBasedOnShopUtils = (shop, defaultWidth) => {
  let shopSpecificWidth = defaultWidth;
  switch (shop) {
    case 'sneaker-dog.myshopify.com':
      shopSpecificWidth = 320;
      break;

    case 'jolies-culottes.myshopify.com':
      shopSpecificWidth = 480;
      break;

    default:
      break;
  }
  return shopSpecificWidth;
};
